import {UnderlinedHeader} from "../../components";
import React from "react";
import {Switch} from "../../components/DisablableSwitch/Switch";
import {InvestorGroupMemberType, InvestorGroupType} from "../../ClientManagement/models/InvestorGroupType";
import moment from "moment/moment";
import {useAnalyticsTrackers} from "../../utils/useAnalyticsTrackers";

export const LifestyleGoalFunding = ({
                                         onToggle,
                                         isOn,
                                         investorGroup,
                                         sufficientYears,
                                         isProfileWithProposalsOrArchived = false
                                     }: {
    onToggle: () => void,
    isOn: boolean,
    investorGroup: InvestorGroupType,
    sufficientYears: number,
    isProfileWithProposalsOrArchived?: boolean
}) => {
    let firstName: string = "";
    let clientAge: number = 0;
    if (investorGroup.planningPeriod.memberType === InvestorGroupMemberType.PARTNER) {
        firstName = investorGroup.partnerMember?.firstName!;
        clientAge = (moment().diff(investorGroup.partnerMember?.birthdate, 'years'))
    } else {
        firstName = investorGroup.primaryMember?.firstName;
        clientAge = (moment().diff(investorGroup.primaryMember?.birthdate, 'years'))
    }
    const fundedPortfolioThroughAgeDescription: string = `${((clientAge + sufficientYears) - 1)} (${firstName}, in ${sufficientYears} years)`;

    const { page } = useAnalyticsTrackers();

    return <section aria-label="Goal Funding" className="lifestyle-spending-section">
        <UnderlinedHeader
            className="lifestyle-spending-section-header"
            primaryText='Goal Funding'
        />

        <div className="lifestyle-goal-funding-table">
            <label>
                <b>Fund using <br/> Non-Investable Assets</b>
            </label>
            <span
                className="funded-by-non-investable-assets-slider-container"
            >
                <span className="funded-by-non-investable-assets-slider"
                      data-testid="funded-by-non-investable-assets-slider"
                      //onClick={onToggle}
                      onClick={() => {
                          onToggle();
                          page("Goals_EditLifestyleSpending_Toggle_FundedBy_NonInvestableAssets");
                      }}
                >
                    <Switch
                        id="Fund using Non-Investable Assets"
                        isOn={isOn}
                        offText="OFF"
                        onText="ON"
                        stateTextPosition="right"
                        isDisabled={isProfileWithProposalsOrArchived}
                    />
                </span>
            </span>
        </div>
        <div className="lifestyle-goal-funding-table">
            <label>
                <b></b>
            </label>
            <span className="paddingright-xl" style={{fontSize: "13px"}}>In order to alleviate investable insufficiency, this option <br/> can be enabled to fund latter years of lifestyle <br/> spending using non-investable assets.</span>
        </div>
        {isOn &&
            <div className="lifestyle-goal-funding-table">
                <label>
                    <b>Funded by Portfolio Through Age</b>
                </label>
                <div data-testid="funded-by-portfolio-through-age" className="funded-by-portfolio-through-age-description">
                    {fundedPortfolioThroughAgeDescription}
                </div>
            </div>
        }
    </section>
}
